import DCSTab from "./DCSTab";
import EstimationTab from "./EstimationTab";
import MCS3 from "./MCS3";
import PCS from "./PCSTab";
import PMSTab2 from "./PMSTab2";
import PVModeling from "./PV3";

export const CommonTabs = (reRender, project) => [
  {
    id: "Est.",
    title: "EstimationTab",
    panel: <EstimationTab reRender={reRender} />,
  },
  {
    id: "DCS",
    title: "DCSPage",
    panel: <DCSTab reRender={reRender} />,
  },
  {
    id: "MCS",
    title: "MCSPage",
    panel: <MCS3 project={project} />,
  },

  {
    id: "PCS",
    title: "PCS",
    panel: <PCS />,
  },
  {
    id: "PMS",
    title: "PMSTab",
    panel: <PMSTab2 />,
  },

  {
    id: "",
    title: "PV Modeling",
    panel: <PVModeling />,
  },
];
